import { HIDE_TOOLTIP } from '../../reducer';

export const TOGGLE_EDIT = 'TOGGLE_EDIT';
export const SHOW_TOOLTIP = 'Account/Information/SHOW_TOOLTIP';

export const showTooltip = tooltip => ({
  type: SHOW_TOOLTIP,
  tooltip
});
export const toggleEdit = () => ({
  type: TOGGLE_EDIT
});

const initialState = {
  editing: false,
  activeTooltip: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_EDIT:
      return { ...state, editing: !state.editing };
    case SHOW_TOOLTIP:
      return {
        ...state,
        activeTooltip: action.tooltip
      };
    case HIDE_TOOLTIP:
      return {
        ...state,
        activeTooltip: null
      };
    default:
      return state;
  }
};
